import React from 'react'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'
import MaterialIcon from '../MaterialIcon'
import { hide } from '../Modal'
import { useTheme } from '../ThemeProvider/ThemeProvider'
import bg from '../../../assets/images/discount_banner.png'
import { ReactComponent as Frame } from './frame.svg'
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg'
import styles from './DiscountModal.module.scss'

const MODAL_DATA_MAPPING = {
  title: 'Act now Get 50% off!',
  content: (
    <>
      <h4>A Surprise Awaits You. Check your email!</h4>
      <span>
        Check your inbox for a <strong>special 50% OFF</strong> offer from FinalBit! Didn’t receive our email? Look in your junk folder and mark it as ‘Not spam’ to stay updated on future offers.
      </span>
      <span>How to Claim Your Discount?</span>
      <div className={styles.benefits}>
        <div className={styles.benefit}>
          <MaterialIcon variant='selected' name='savings' outlined style={{ fontSize: 32 }} />
          <span>
            <strong>Current Creator and Pro Subscribers:</strong> <br />
            Look for an email from <span style={{ color: '#1D6EE3' }}>updates@finalbitai.com</span>.
            Simply reply to our email with the message <strong>“Give me my 50% plot twist!”</strong> to claim your discount.
          </span>
        </div>
        <div className={styles.benefit}>
          <MaterialIcon variant='selected' name='movie_filter' outlined style={{ fontSize: 32 }} />
          <span>
            <strong>New Subscribers:</strong><br />
            New to FinalBit and haven’t received an email from us?
            Just write to us at <span style={{ color: '#1D6EE3' }}>updates@finalbitai.com</span>,
            and we’ll apply your 50% OFF promo!
          </span>
        </div>
      </div>
      <span>
        Single-use offer, available to both Creator and Pro subscribers.
        For existing subscriptions, the discount will be applied to your next billing cycle.
        If you’re upgrading from a free to a paid plan, the discount can be applied immediately upon upgrade.
        This offer is valid for a limited time.
      </span>
    </>
  )

}

const CloseButton = () => {
  return (
    <button
      type='button'
      aria-label='Close Modal'
      aria-labelledby='close-modal'
      className={styles.modalClose}
      onClick={() => {
        // eslint-disable-next-line no-undef
        localStorage.setItem('discountModalShown', true)
        hide('claimDiscount')
      }}
      id='closeModalId'
    >
      <div className={styles.iconContainer}>
        <CloseIcon />
      </div>

    </button>
  )
}

const UpgradePlanBody = ({ closable = true, containerStyle }) => {
  const { themeMode } = useTheme() || {}
  const data = MODAL_DATA_MAPPING
  return (
    <div className={`${styles.container} ${styles[themeMode]}`} style={containerStyle}>
      <Row align='top' style={{ width: '100%' }}>
        <Col lg={12} xs={24} className={styles.left}>
          <img src={bg} alt='upgrade plan bg' />
          <div className={styles.textBlock}>
            <div className={styles.gem}>
              <div className={styles.bg}>
                <Frame />
              </div>
              <div className={styles.iconInner}>
                <MaterialIcon
                  outlined variant='label-default'
                  name='diamond'
                  style={{ fontSize: 40, color: 'rgba(228, 147, 29, 1)' }}
                />
              </div>
            </div>
            <span className={styles.title}>Act now</span>
            <span className={styles.title}>
              <strong>Get 50% off!</strong>
            </span>
          </div>
          <div className={styles.learnMore}>
            <a href='https://www.nolanai.app/pricing' target='_blank' rel='noreferrer'>Learn more about NolanAI Premium
              subscription
            </a>
          </div>
        </Col>
        <Col lg={12} xs={24} className={styles.right}>
          {closable && <CloseButton />}
          {data.content}
        </Col>
      </Row>
    </div>
  )
}

export default UpgradePlanBody
